import { tv } from 'tailwind-variants';

export const tailwindVariants = tv({
  slots: {
    base: ['bg-components-icon-card-listing-color-brand-bg', 'grid', 'relative'],
    absoluteOverlay: [
      'col-start-1',
      'row-start-1',
      'self-center',
      'absolute',
      'w-full',
      'h-full',
      'overflow-hidden',
      '[&_svg]:h-full',
      '[&_svg]:w-full',
    ],
    innerContainer: ['col-start-1', 'row-start-1'],

    flexCenter: ['flex', 'flex-col', 'gap-0', 'items-center', 'justify-center', 'relative'],
    cardContainer: [
      'bg-components-icon-card-listing-color-inner-bg',
      'md:p-10',
      'py-components-icon-card-listing-spacing-small-padding-inner-y',
      'px-components-icon-card-listing-spacing-small-padding-inner-x',
      'flex',
      'flex-col',
      'gap-0',
      'items-start',
      'justify-start',
      'shrink-0',
      'md:w-[450px]',
      'w-full',
      'relative',
      'md:my-components-promo-spacing-large-padding-y',
      'md:mx-components-promo-spacing-large-padding-x',
      'rounded-themes-spacing-radius-large-image-card',
    ],
    titleText: [
      'text-components-promo-color-default-title',
      'text-left',
      'font-header-large-xSmall',
      'text-header-large-xSmall',
      'leading-header-large-xSmall',
      'relative',
      'self-stretch',
    ],
    descriptionText: [
      'text-components-promo-color-default-body',
      'text-left',
      'font-bodySans-medium',
      'text-bodySans-medium',
      'leading-bodySans-medium',
      'relative',
      'self-stretch',
    ],
    paginationText: [
      'text-components-pagination-on-white-accent-scroll',
      'text-left',
      'font-header-small-xSmall',
      'text-header-small-xSmall',
      'leading-header-small-xSmall',
      'relative',
      'self-stretch',
      'transition-all',
      'ease-in-out',
    ],
    progressBarWrapper: [
      'rounded-components-pagination-scrollbar-radius',
      'flex',
      'gap-2',
      'items-start',
      'justify-end',
      'self-stretch',
      'shrink-0',
      'relative',
    ],
    progressBar: [
      'bg-components-pagination-on-white-bg',
      'rounded-components-pagination-scrollbar-radius',
      'flex-1',
      'h-1',
      'relative',
      'overflow-hidden',
    ],
    progressFill: [
      'bg-components-pagination-on-white-accent-scroll',
      'transition-all',
      'duration-500',
      'rounded-components-pagination-scrollbar-radius',
      'h-1',
      'absolute',
      'left-0',
      'top-0',
    ],
    questionText: [
      'text-themes-general-surface-color-light-title',
      'text-center',
      'md:font-header-large-small',
      'md:text-header-large-small',
      'md:leading-header-large-small',
      'font-header-small-small',
      'text-header-small-small',
      'leading-header-small-small',
      'relative',
    ],
    buttonGroup: [
      'flex',
      'gap-4',
      'items-start',
      'justify-center',
      'flex-wrap',
      'w-full',
      '[&>*]:flex-1',
    ],
    quizWrapper: [
      'pb-10 flex flex-col gap-6 items-center justify-center self-stretch shrink-0 relative',
    ],
    progressBarContainer: [
      'flex flex-col gap-spacing-spacing-3 items-start justify-center flex-1 relative w-full',
    ],
    quizContainer: [
      'pt-10 pb-10 flex flex-col gap-6 items-center justify-start self-stretch shrink-0 relative',
    ],
    quizSteps: ['flex flex-row-reverse justify-between self-stretch '],
    quizLogo: [
      'shrink-0 w-components-icon-card-dimensions-large-big-icon-width h-components-icon-card-dimensions-large-big-icon-height relative overflow-hidden',
    ],
    isFirstQuestionStyle: [''],
  },

  variants: {
    progressState: {
      start: { progressFill: ['right-[100%]'] },
      mid: { progressFill: ['right-[22%]'] },
      end: { progressFill: ['right-[0%]'] },
    },
    isFirstQuestion: {
      true: {
        isFirstQuestionStyle: ['hidden'],
      },
    },
  },
});
